/* eslint-disable */

const VERSION_ID_PATTERN = /window\.versionId\s*=\s*"([^"]+)"/;
const VERSION_RELOAD_FLAG = "sw_version_reload";

const clearServiceWorkerAndCaches = async () => {
	if ("serviceWorker" in navigator) {
		const registrations = await navigator.serviceWorker.getRegistrations();
		await Promise.all(registrations.map((registration) => registration.unregister()));
	}
	if ("caches" in window) {
		const cacheNames = await window.caches.keys();
		await Promise.all(cacheNames.map((cacheName) => caches.delete(cacheName)));
	}
};

/**
 * Dev server should not run behind a production service worker (stale UI after code changes).
 * Runs after first paint so cleanup cannot block or reload before React mounts.
 */
export const prepareDevelopmentClient = async () => {
	if (process.env.NODE_ENV !== "development") {
		return;
	}
	await clearServiceWorkerAndCaches();
};

/**
 * If the running bundle is older than index.html on the server, drop SW caches and reload once.
 * Uses a one-shot session flag (not version equality) so a mixed HTML/JS cache cannot loop.
 */
export const ensureProductionClientIsCurrent = async () => {
	if (process.env.NODE_ENV !== "production") {
		return;
	}

	// After a version-mismatch reload, do not check again this session tab.
	if (sessionStorage.getItem(VERSION_RELOAD_FLAG) === "1") {
		sessionStorage.removeItem(VERSION_RELOAD_FLAG);
		return;
	}

	const clientVersion =
		process.env.REACT_APP_GIT_SHA || window.versionId || localStorage.getItem("app_version");
	if (!clientVersion || clientVersion === "dev") {
		return;
	}

	try {
		const publicUrl = process.env.PUBLIC_URL || "";
		const indexUrl = `${publicUrl}/index.html?build-check=${Date.now()}`;
		const response = await fetch(indexUrl, { cache: "no-store", credentials: "same-origin" });
		if (!response.ok) {
			return;
		}

		const html = await response.text();
		const match = html.match(VERSION_ID_PATTERN);
		const serverVersion = match && match[1];
		if (!serverVersion || serverVersion === clientVersion) {
			return;
		}

		console.log(
			`App update detected (${clientVersion} -> ${serverVersion}). Clearing caches and reloading once...`
		);
		sessionStorage.setItem(VERSION_RELOAD_FLAG, "1");
		await clearServiceWorkerAndCaches();
		window.location.reload();
	} catch (error) {
		console.warn("Could not verify app version:", error);
	}
};

/**
 * Reload only when we intentionally activated a waiting worker (see markServiceWorkerUpdatePending).
 * Unconditional controllerchange → reload fights first-claim after unregister and causes A/B loops.
 */
export const markServiceWorkerUpdatePending = () => {
	window.__ftrSwUpdatePending = true;
};

export const registerServiceWorkerReloadOnActivate = () => {
	if (process.env.NODE_ENV !== "production" || !("serviceWorker" in navigator)) {
		return;
	}

	let refreshing = false;
	navigator.serviceWorker.addEventListener("controllerchange", () => {
		if (!window.__ftrSwUpdatePending || refreshing) {
			return;
		}
		refreshing = true;
		window.__ftrSwUpdatePending = false;
		window.location.reload();
	});
};

/* eslint-enable */
